<template>
  <div>
    <SellHeader :img_header="header_image" header="เมนูคำสั่งซื้อ" link_back="sell/all"/>
    <MenuSell/>
    <Order_partner_main/>
  </div>
</template>

<script>
import MenuSell from "@/components/admin/sell/menusell/MenuSell";
import Order_partner_main from "@/components/admin/sell/Order_partner_main";
import SellHeader from "@/components/admin/sell/header_sell/SellHeader";
import HeaderImage from "@/assets/order_all.png";
export default {
  name: "OrderPartnerMain",
  components: {
    SellHeader,
    Order_partner_main,
    MenuSell
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
